import { component } from "picoapp";

export default component((node, ctx) => {
  const form = node;
  form.addEventListener("submit", handleSubmit);
});

function handleSubmit(event) {
  event.preventDefault();
  const data = new FormData(event.target);
  fetch("https://formspree.io/f/xoqrdljg", {
    method: "post",
    body: data,
    headers: {
      Accept: "application/json",
    },
  })
    .then((response) => {
      if (response.ok) {
        const wrapper = document.querySelector(".js-corp-form-wrapper");
        const successMsg = document.querySelector(".js-corp-form-success");
        wrapper.style.display = "none";
        successMsg.style.display = "";
        successMsg.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
        event.target.reset();
      } else {
        document.querySelector(".js-corp-error").innerHTML =
          "There was an error submitting your form. Please try again.";
      }
    })
    .catch((e) => {
      document.querySelector(".js-corp-error").innerHTML =
        "There was an error submitting your form. Please try again.";
    });
}
